export default "__VITE_ASSET__oswEM9mV__"